"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

/**
 * The storefront's themed root (`StorefrontShell`'s `[data-storefront]`), for a
 * popup to portal into. The store's colours, fonts and `data-theme` are inline
 * on that element, so a popup portalled to `<body>` paints in the platform's
 * palette instead of the store's. `undefined` on the server and outside a
 * storefront, where the portal falls back to `<body>`.
 */
export function useStorefrontRoot(): HTMLElement | undefined {
	return useSyncExternalStore(
		subscribe,
		() => document.querySelector<HTMLElement>("[data-storefront]") ?? undefined,
		() => undefined,
	);
}
